import { action } from 'typesafe-actions';
import { COUNTER_TYPES } from './types';

export const incrementAsyncRequest = () =>
  action(COUNTER_TYPES.INCREMENT_REQUEST);

export const incrementSuccess = () => action(COUNTER_TYPES.INCREMENT_SUCCESS);

export const decrement = () => action(COUNTER_TYPES.DECREMENT_SUCCESS);
